import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const PATH_TO_VIEW = {
  '/today': 'today',
  '/upcoming': 'upcoming',
  '/anytime': 'anytime',
  '/someday': 'someday',
  '/logbook': 'logbook',
  '/inbox': 'inbox',
};
const initialActiveView =
  (typeof window !== 'undefined' && PATH_TO_VIEW[window.location.pathname]) || 'inbox';
const initialSidebarCollapsed =
  typeof window !== 'undefined' ? window.innerWidth < 768 : false;

const useAppStore = create(
  persist(
    (set) => ({
      // Persistent UI prefs
      nightMode: false,
      activeView: initialActiveView,

      // Ephemeral UI state
      activeProjectId: null,
      activeAreaId: null,
      selectedTaskId: null,
      sidebarCollapsed: initialSidebarCollapsed,
      commandPaletteOpen: false,
      focusModeOpen: false,
      brainDumpOpen: false,
      searchQuery: '',

      // Theme
      toggleNightMode: () => set((s) => ({ nightMode: !s.nightMode })),
      setNightMode: (value) => set({ nightMode: value }),

      // Navigation
      setActiveView: (view) =>
        set({ activeView: view, activeProjectId: null, activeAreaId: null, selectedTaskId: null }),
      setActiveProject: (id) =>
        set({ activeProjectId: id, activeView: null, activeAreaId: null, selectedTaskId: null }),
      setActiveArea: (id) =>
        set({ activeAreaId: id, activeView: null, activeProjectId: null, selectedTaskId: null }),
      setSelectedTask: (id) => set({ selectedTaskId: id }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      toggleCommandPalette: () => set((s) => ({ commandPaletteOpen: !s.commandPaletteOpen })),
      setCommandPalette: (v) => set({ commandPaletteOpen: v }),
      setFocusMode: (v) => set({ focusModeOpen: v }),
      setBrainDump: (v) => set({ brainDumpOpen: v }),
      setSearchQuery: (q) => set({ searchQuery: q }),
    }),
    {
      name: 'docket-app',
      partialize: (state) => ({
        nightMode: state.nightMode,
        activeView: state.activeView,
      }),
    }
  )
);

export default useAppStore;
